module.exports = __webpack_public_path__ + "static/media/sage-logo.fa2406cb.svg";